window.SnoozebabyProductReadmore = {
  translations: {
    nl: { expand: 'Lees meer', collapse: 'Lees minder' },
    en: { expand: 'Read more', collapse: 'Read less' },
    fr: { expand: 'Lire la suite', collapse: 'Réduire' },
    de: { expand: 'Mehr lesen', collapse: 'Weniger' },
  },

  capitalizeFirst(text) {
    const trimmed = (text || '').trim();
    if (!trimmed) return trimmed;
    return trimmed.charAt(0).toLocaleUpperCase() + trimmed.slice(1);
  },

  formatSpecLabel(label) {
    const trimmed = (label || '').trim();
    if (!trimmed) return trimmed;

    const normalized = this.normalizeLabel(trimmed);
    const labelOverrides = {
      'tog-waarde': 'TOG-waarde',
      'tog waarde': 'TOG-waarde',
    };
    if (labelOverrides[normalized]) {
      return labelOverrides[normalized];
    }

    return this.capitalizeFirst(trimmed.toLocaleLowerCase());
  },

  formatSpecValue(value) {
    return this.capitalizeFirst(value);
  },

  normalizeLabel(label) {
    return label
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .trim();
  },

  splitWeightFromDimensions(value) {
    const weightPattern = /(?:,|\s|;\s*)(?:en\s+)?(?:gewicht|weight)\s*:?\s*([^,;]+)/i;
    const match = value.match(weightPattern);
    if (!match) return null;

    const weightValue = match[1].trim();
    let dimensionsValue = value.replace(weightPattern, '').replace(/\s+en\s*$/i, '').trim();
    dimensionsValue = dimensionsValue.replace(/[,\s;]+$/, '').trim();
    if (!weightValue) return null;

    return {
      dimensionsValue: dimensionsValue || value,
      weightLabel: /^en/i.test(document.documentElement.lang || '') ? 'Weight' : 'Gewicht',
      weightValue,
    };
  },

  createSpecRow(label, value, options = {}) {
    const row = document.createElement('li');
    row.className = 'sb-product-specs__row';

    if (options.hidden) {
      row.hidden = true;
    }
    if (options.skuRow) {
      row.dataset.sbSkuRow = 'true';
    }

    const labelEl = document.createElement('span');
    labelEl.className = 'sb-product-specs__label';
    labelEl.textContent = this.formatSpecLabel(label);

    const valueEl = document.createElement('span');
    valueEl.className = 'sb-product-specs__value';
    if (options.eanRow) {
      valueEl.classList.add('sb-product-specs__value--ean');
      valueEl.dataset.sbEanValue = 'true';
    }
    if (options.skuRow) {
      valueEl.dataset.sbSkuValue = 'true';
    }
    valueEl.textContent = options.rawValue ? value : this.formatSpecValue(value);

    row.append(labelEl, valueEl);
    return row;
  },

  findSpecsSourceList(container) {
    const marked = container.querySelector('ul.sb-desc-specs');
    if (marked) return marked;

    const lists = [...container.querySelectorAll('ul')];
    const outsideUsps = lists.filter((ul) => !ul.closest('.sb-desc-usps'));
    if (!outsideUsps.length) return null;
    return outsideUsps[outsideUsps.length - 1];
  },

  buildSpecsTable(container) {
    const sourceList = this.findSpecsSourceList(container);
    if (!sourceList) return null;

    const specsList = document.createElement('ul');
    specsList.className = 'sb-product-specs';

    sourceList.querySelectorAll(':scope > li').forEach((item) => {
      const text = item.textContent.trim();
      const colonIndex = text.indexOf(':');
      if (colonIndex === -1) return;

      const label = text.slice(0, colonIndex).trim();
      const value = text.slice(colonIndex + 1).trim();
      if (!label || !value) return;

      const normalizedLabel = this.normalizeLabel(label);
      let displayValue = value;
      let split = null;

      if (['afmetingen', 'dimensions', 'maat', 'size'].includes(normalizedLabel)) {
        const nextText = item.nextElementSibling?.textContent?.trim() || '';
        const nextIsWeight = /^(gewicht|weight)\s*:/i.test(nextText);

        if (nextIsWeight) {
          displayValue = value.replace(/\s+en\s*$/i, '').trim();
        } else {
          split = this.splitWeightFromDimensions(value);
          if (split) {
            displayValue = split.dimensionsValue;
          }
        }
      }

      specsList.appendChild(this.createSpecRow(label, displayValue));

      if (split) {
        specsList.appendChild(this.createSpecRow(split.weightLabel, split.weightValue));
      }
    });

    if (!specsList.children.length) return null;

    sourceList.replaceWith(specsList);
    return specsList;
  },

  initTabs(root) {
    if (!root) return;
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    if (!tabs.length) return;

    const selectTab = (tab) => {
      tabs.forEach((item) => {
        const on = item === tab;
        item.setAttribute('aria-selected', String(on));
        item.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + delta + tabs.length) % tabs.length];
        next.focus();
        selectTab(next);
      });
    });
  },

  appendIdentifierRows(container, specsList) {
    let list = specsList;
    if (!list) {
      list = document.createElement('ul');
      list.className = 'sb-product-specs';
      container.appendChild(list);
    }

    const skuLabel = container.dataset.sbSkuLabel || 'Artikelnummer';
    const eanLabel = container.dataset.sbEanLabel || 'EAN';
    const eanFallback = container.dataset.sbEanFallback || '';
    const sku = container.dataset.sbSku || '';
    const ean = container.dataset.sbEan || '';

    if (sku) {
      list.appendChild(
        this.createSpecRow(skuLabel, sku, { skuRow: true, rawValue: true })
      );
    } else {
      list.appendChild(
        this.createSpecRow(skuLabel, sku, {
          skuRow: true,
          rawValue: true,
          hidden: true,
        })
      );
    }

    list.appendChild(
      this.createSpecRow(eanLabel, ean || eanFallback, {
        eanRow: true,
        rawValue: !ean,
      })
    );

    return list;
  },

  bindVariantSync(container) {
    const syncFromVariant = (variant) => {
      if (!variant) return;

      const skuValue = container.querySelector('[data-sb-sku-value]');
      const skuRow = container.querySelector('[data-sb-sku-row]');
      const eanValue = container.querySelector('[data-sb-ean-value]');

      if (skuValue) {
        const sku = variant.sku || '';
        skuValue.textContent = sku;
        if (skuRow) {
          skuRow.hidden = sku === '';
        }
      }

      if (eanValue) {
        eanValue.textContent =
          variant.barcode || container.dataset.sbEanFallback || eanValue.textContent;
      }
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.variant) syncFromVariant(data.variant);
      });
    }

    const productInfo = container.closest('product-info');
    const variantInput = productInfo?.querySelector('input[name="id"]');
    const variantsScript = document.querySelector('script[data-product-variants]');

    if (variantInput && variantsScript) {
      try {
        const variants = JSON.parse(variantsScript.textContent);
        const current = variants.find((v) => String(v.id) === String(variantInput.value));
        if (current) syncFromVariant(current);
      } catch {
        /* ignore */
      }
    }
  },

  scrollToTop(anchor) {
    if (!anchor) return;
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.section-header');
    const offset = (header && header.offsetHeight) || 0;
    const top = anchor.getBoundingClientRect().top + window.scrollY - offset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  },

  truncateSentences(text, maxSentences = 2) {
    const trimmed = text.trim();
    if (!trimmed) return trimmed;

    // Protect decimals (e.g. TOG 1.0) so periods are not treated as sentence ends.
    const DECIMAL_PLACEHOLDER = '\u0000';
    const protectedText = trimmed.replace(/(\d)\.(\d)/g, `$1${DECIMAL_PLACEHOLDER}$2`);

    const parts = protectedText.match(/[^.!?…]+[.!?…]+(?:\s+|$)|[^.!?…]+$/gu);
    if (!parts || parts.length <= maxSentences) return trimmed;

    return parts
      .slice(0, maxSentences)
      .join('')
      .replaceAll(DECIMAL_PLACEHOLDER, '.')
      .trim();
  },

  init(contentId, toggleId, locale, specsHostId) {
    const content = document.getElementById(contentId);
    if (!content || content.dataset.sbReadmoreReady === 'true') return;
    content.dataset.sbReadmoreReady = 'true';

    const tabsRoot = content.closest('[data-sb-info-tabs]');
    const specsHost = specsHostId ? document.getElementById(specsHostId) : null;

    content.classList.add('sb-readmore--pending');
    if (tabsRoot) tabsRoot.classList.add('sb-readmore--pending');

    const finishInit = () => {
      content.classList.remove('sb-readmore--pending');
      if (tabsRoot) tabsRoot.classList.remove('sb-readmore--pending');
    };

    this.initTabs(tabsRoot);

    if (specsHost) {
      ['sbSkuLabel', 'sbEanLabel', 'sbEanFallback', 'sbSku', 'sbEan'].forEach((key) => {
        if (content.dataset[key] != null) specsHost.dataset[key] = content.dataset[key];
      });
    }

    let specsList = this.buildSpecsTable(content);
    if (specsList && specsHost && specsList.parentNode !== specsHost) {
      specsHost.appendChild(specsList);
    }
    specsList = this.appendIdentifierRows(specsHost || content, specsList);
    this.bindVariantSync(specsHost || content);

    const firstParagraph = content.querySelector('p');
    if (!firstParagraph) {
      finishInit();
      return;
    }

    firstParagraph.classList.add('description-intro');

    const strings = this.translations[locale] || this.translations.en;
    const toggle = document.createElement('button');
    toggle.className = 'readmore-toggle';
    toggle.id = toggleId;
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = strings.expand;

    const moreBlock = content.querySelector('.sb-desc-more');
    if (moreBlock) {
      moreBlock.hidden = true;
      moreBlock.classList.add('description-extra');
      firstParagraph.after(toggle);

      let isExpanded = false;
      const placeToggle = () => {
        if (isExpanded) {
          moreBlock.after(toggle);
        } else {
          firstParagraph.after(toggle);
        }
      };

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        isExpanded = !isExpanded;
        moreBlock.hidden = !isExpanded;
        placeToggle();
        toggle.setAttribute('aria-expanded', String(isExpanded));
        toggle.textContent = isExpanded ? strings.collapse : strings.expand;
        if (!isExpanded) {
          this.scrollToTop(tabsRoot || content);
        }
      });

      finishInit();
      return;
    }

    const fullIntro = firstParagraph.textContent.trim();
    const truncated = this.truncateSentences(fullIntro, 2);
    const needsTruncate = truncated.length < fullIntro.length;

    if (needsTruncate) {
      firstParagraph.dataset.fullText = fullIntro;
      firstParagraph.textContent = truncated;
    }

    const extraParagraphs = [];
    let sibling = firstParagraph.nextElementSibling;
    while (sibling) {
      if (sibling.tagName === 'P') {
        extraParagraphs.push(sibling);
      }
      sibling = sibling.nextElementSibling;
    }

    const insertAfter = extraParagraphs.length
      ? extraParagraphs[extraParagraphs.length - 1]
      : firstParagraph;
    insertAfter.after(toggle);

    if (!needsTruncate && extraParagraphs.length === 0) {
      toggle.hidden = true;
      finishInit();
      return;
    }

    let isExpanded = false;

    extraParagraphs.forEach((el) => {
      el.hidden = true;
      el.classList.add('description-extra');
    });

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      isExpanded = !isExpanded;

      if (needsTruncate) {
        firstParagraph.textContent = isExpanded ? fullIntro : truncated;
      }

      extraParagraphs.forEach((el) => {
        el.hidden = !isExpanded;
      });

      toggle.setAttribute('aria-expanded', String(isExpanded));
      toggle.textContent = isExpanded ? strings.collapse : strings.expand;
      if (!isExpanded) {
        this.scrollToTop(tabsRoot || content);
      }
    });

    finishInit();
  },
};
